import React from "react";
import MovmoIdentityChip from "../MovmoIdentityChip";
import { DemoAirline } from "../../config/movmoIdentity";

interface HeroBannerProps {
    airline?: DemoAirline;
}

const HeroBanner: React.FC<HeroBannerProps> = ({ airline = "pa" }) => {
    return (
        <section className="relative h-[562px] overflow-hidden">
            {/* Background Image */}
            <div className="absolute inset-0">
                <div
                    className="w-full h-full bg-cover bg-center"
                    style={{
                        backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.6), rgba(0,0,0,0.4)), url('https://images.unsplash.com/photo-1540339832862-474599807836?q=80&w=2187')`,
                    }}
                />
            </div>

            {/* Hero Content */}
            <div
                className="relative z-10 h-full flex flex-col items-start justify-center"
                style={{ marginTop: "-70px" }}
            >
                <div className="mx-auto max-w-[1152px] w-full px-8 lg:px-12">
                    <div className="max-w-[472px] mt-20 lg:mt-0 mx-auto lg:mx-0">
                        <h1 className="text-3xl lg:text-5xl font-bold text-white mb-4 leading-tight">
                            Genuine care
                            <br />
                            in the skies
                        </h1>
                        <p className="text-xl lg:text-lg text-white mb-8 font-medium md:mr-0 mr-8">
                            Experience our signature care — the Filipino way
                        </p>
                        {/* Movmo identity chip: fixed bottom-left slot, out of the hero flow */}
                        <MovmoIdentityChip airline={airline} noticeColor="#fff" />
                        <button
                            className="text-white px-6 lg:px-8 py-2.5 lg:py-3 rounded font-semibold text-sm uppercase tracking-wider transition-colors"
                            style={{ backgroundColor: "#0047ba" }}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                    "#003a96")
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor =
                                    "#0047ba")
                            }
                        >
                            LEARN MORE
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroBanner;
